import React, { memo } from 'react';

import { TruncatedText } from '../TruncatedText/TruncatedText';

interface IFileNameProps {
  name: string;
  className?: string;
}

export const FileName = memo<IFileNameProps>((props) => {
  const { name, className } = props;
  return <TruncatedText className={className}>{name}</TruncatedText>;
});
